import React, { Component } from 'react';
//import {Link} from 'react-router-dom';

class BigButton extends Component {
    render() {
        const { 
            size = '300px',
            height,
            text = 'Click Me',
            onClick,
            className = '',
            type = 'button',
            variant = 'primary',
            appearance = 'default',
            style = {}
        } = this.props;

        // Predefined style configurations
        const appearances = {
            default: {
                height: '60px',
                padding: '12px 24px',
                fontSize: '1rem',
                border: '2px solid #ccc',
                borderRadius: '8px'
            },
            large: {
                height: '200px',
                padding: '24px 48px',
                fontSize: '1.5rem',
                fontWeight: 'bold',
                border: '3px solid #ccc',
                borderRadius: '12px'
            },
            compact: {
                height: '40px',
                padding: '8px 16px',
                fontSize: '0.875rem',
                border: '1px solid #ccc',
                borderRadius: '4px'
            }
        };

        // Create style object with dynamic dimensions and appearance
        const buttonStyle = {
            width: size,
            height: height || appearances[appearance].height,
            ...appearances[appearance],
            ...style,
            boxSizing: 'border-box' // Ensure padding doesn't affect final size
        };

        return (
            <button
                type={type}
                className={`btn btn-${variant} ${className}`}
                style={buttonStyle}
                onClick={onClick}
            >
                {text}
            </button>
        );
    }
}

export default BigButton;